import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';

const GenerateDetailsButton = (props) => {
  if ((props.environment == 'development' || props.environment == 'staging') && props.enabled){
    return(
      <div style={props.style !== undefined ? props.style : {position: 'absolute', bottom: '0', right: '110px', marginBottom: '15px', zIndex: '10'}}>
        <Button
          type="submit"
          onClick={props.generateDetails}
          className="btn btn-success">{props.text}</Button>
      </div>
    );
  } else {
    return(null);
  };
};

export default GenerateDetailsButton;
